<template>
  <v-container grid-list-xs class="pa-0 ma-0 px-2" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">Administración Licencias</span>
      </v-col>
       <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs
          class="py-2 px-0"
          :items="aItemsBreadcrumbs"
          divider=">"
        >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col >
        <v-card elevation="0">
          <v-card-text>
            <ExportarLicencias :bModalDescargas="bModalDescargas" @onClose="onClose" :oArchivos="oArchivos"/>
            
            <DataTable :columns="cpmHeaders" :data="aItem" bFilter :key="nKeyRefresh" @onDataFromApi="onBlur" bExportar>
              <template #btn_exportar>
                <v-btn color="primary" @click="onExportar" rounded :loading="bLoadingExportar" :disabled="bLoadingExportar">
                  <v-icon>mdi-download</v-icon>
                  Exportar
                </v-btn>
              </template>
              <template #btn_personalizado="{ item }">
                <v-btn icon color="primary" @click="onVerDetalleCliente(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="onEditarLicencia(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </DataTable>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col v-else>
        <EmptyView />
      </v-col> -->
    </v-row>
    
  </v-container>
</template>

<script>
import ExportarLicencias from '@/views/Licencias/components/ExportarLicencias.vue';
import  axiosServices  from '@/services/axiosServices.js';
import DataTable from '@/components/Grid/CustomGrid.vue';

export default {
  name:"AdministracionLicencias",
  components: {
    ExportarLicencias,
    DataTable
  },
  data() {
    return {
      nKeyRefresh:0,
      aItem: [],
      sNombreTabla: 'Licencias',
      aItemsBreadcrumbs: [
        {
          text: 'Inicio',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Control de licencias',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Administracion Licencias',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
      bModalDescargas:false,
      bLoadingExportar: false,
      oArchivos:{}
    }
  },
  mounted(){
    this.onCargarLicenciasClientes();
  },
  methods: {
    onClose() {
      this.bModalDescargas = false;
    },
    onBlur() {
      this.nKeyRefresh++
    },
    async onExportar() {
      try {
        // Limpiar archivos previos
        this.oArchivos = {};

        this.bLoadingExportar = true;

       
        const { nStatusCode, aData } = await axiosServices.postConfiguration(`licencias/exportarClientes`, {} , true, "")
        if (nStatusCode === 200) {
          this.oArchivos = aData;
          this.bModalDescargas = true;
        }
        this.bLoadingExportar = false;
      } catch (error) {
        this.bLoadingExportar = false;
      }
    },
    async onCargarLicenciasClientes(){
        try {
            const { nStatusCode, aData } = await axiosServices.getConfiguration(`licenciasClientes`, true, "")
            if (nStatusCode === 200) {          
            this.aItem = []
            this.aItem = aData;
            this.nKeyRefresh++;
            }
        } catch (error) {
            error
        }
    },
    onVerDetalleCliente(oItem){
      this.$router.push({ name: 'LicenciasCliente', params: { id: oItem.id } });
    },
    onEditarLicencia(oItem){      
      this.$router.push({ name: 'EditarLicenciasCliente', params: { id: oItem.sub } });
    }
  },
  computed: {
    cpmHeaders() {
        return [
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpID,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "id",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpNombreCliente,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "cliente",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpSubdominio,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "sub",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpLicenciasDisponiblesAPP,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "NoLicenciasAPP",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpLicenciasDisponiblesWEB,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "NoLicenciasWEB",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpAPPLicenciasUso,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "app",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpWEBLicenciasUso,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "web",
            },
            {
                text: "Acciones",
                width: 120,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "actions",
            }

        ];
    }
  },
}
</script>
